export default __webpack_public_path__ + "9ce43a203b9d4213bc5be73064e9b87c.png";